import { useAuthStore } from '@/stores/authStore'

export const useAuth = () => {
  const authStore = useAuthStore()

  const register = async (email, password, firstName, lastName, phone = null) => {
    return authStore.register(email, password, firstName, lastName, phone)
  }

  const login = async (email, password) => {
    return authStore.login(email, password)
  }

  const logout = async () => {
    return authStore.logout()
  }

  const verifyEmail = async (email, token) => {
    return authStore.verifyEmail(email, token)
  }

  const forgotPassword = async (email, recaptchaToken = null) => {
    return authStore.forgotPassword(email, recaptchaToken)
  }

  const validateResetToken = async (token) => {
    return authStore.validateResetToken(token)
  }

  const resetPassword = async (token, newPassword, confirmPassword, recaptchaToken = null) => {
    return authStore.resetPassword(token, newPassword, confirmPassword, recaptchaToken)
  }

  return {
    user: authStore.user,
    isAuthenticated: authStore.isAuthenticated,
    isLoading: authStore.isLoading,
    error: authStore.error,
    register,
    login,
    logout,
    verifyEmail,
    forgotPassword,
    validateResetToken,
    resetPassword
  }
}
